<template>
  <div class="content pr-2 supportEmail">
    <div class="columns">
      <div class="column is-12 pr-0">
        <div
          v-if="loading"
          class="spinner-loader"
        >
          <sync-loader />
          <p>Loading ...</p>
        </div>
        <pagination
          :pagination="this.page"
          per-page="this.perPage"
          :total="this.totalPages"
          @paginateMinus="paginateMinus"
          @paginatePlus="paginatePlus"
        />
        <support-email
          v-for="email in chunkedEmails"
          v-if="!loading"
          v-show="!showReplyDialog"
          :key="email.id"
          :email="email"
          :token="token"
          :user="user"
          @handle="handle"
          @replyTo="replyTo"
        />
        <pagination
          :pagination="this.page"
          per-page="10"
          :total="this.emails.length"
          @paginateMinus="paginateMinus"
          @paginatePlus="paginatePlus"
        />
      </div>
    </div>
    <div
      v-if="showReplyDialog"
      class="modal-box"
    >
      <header class="modal-card-head">
        <span class="modal-card-title">Replying to: {{ replyToName }}</span>
        <button
          class="delete"
          aria-label="close"
          @click="showReplyDialog = false"
        />
      </header>
      <section class="modal-card-body has-text-centered">
        <div class="columns">
          <div class="column">
            <textarea
              ref="replyText"
              style="width:100%; min-height: 250px; height: 100%; border:2px solid #ABABAB;border-radius:5px"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <button
              class="button is-pulled-right"
              style="background-color:#4267b2;color:#FFF"
              @click="sendReply()"
            >
              Reply
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import SupportEmail from './SupportEmail.vue'
  import axios from 'axios'
  import Pagination from '../../helpers/PaginationPerPage.vue'

  export default {
    name: 'ToolsSupportEmails',
    components: {
      SupportEmail,
      Pagination
    },
    props: ['token', 'user'],
    data() {
      return {
        showReplyDialog: false,
        replyToID: null,
        replyToName: '',
        replyToConvID: null,
        edit: false,
        selectedEmail: {},
        emails: [],
        loading: true,
        page: 1,
        perPage: 20,
        totalPages: 0,
      }
    },
    computed: {
      chunkedEmails() {
        return this.emails.slice(0, 50)
      }
    },
    watch: {},
    created() {
      if (!this.user || !this.user.isHost) this.$router.push({name: 'FourZeroFour'})
    },
    mounted() {
      this.getSupportEmails(0)
    },
    methods: {
      paginateMinus() {
        this.page -= 1
        this.getSupportEmails(this.page)
      },
      paginatePlus() {
        this.page += 1
        this.getSupportEmails(this.page)
      },
      handle(obj) {
        this.replyToName = obj.reply_to
        this.replyToID = obj.email_id
        this.replyToConvID = obj.conv_id
        this.$axios({
          method: 'POST',
          url: `admin/supportemails/reply/` + this.replyToConvID + '/true',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || '',
            message: '',
            conv_id: this.replyToConvID
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                showDialog: true,
                error: res.data.error,
                message: res.data.message
              })
            if (!res.data.error) {
              this.showReplyDialog = false
              this.loading = true
              this.getSupportEmails()
            }
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true,message: error.response.data.message})
          })
      },
      sendReply() {
        this.$axios({
          method: 'POST',
          url: `admin/supportemails/reply/` + this.replyToConvID,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || '',
            message: this.$refs.replyText.value,
            conv_id: this.replyToConvID
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                showDialog: true,
                error: res.data.error,
                message: res.data.message
              })
            if (!res.data.error) {
              this.showReplyDialog = false
              this.loading = true
              this.getSupportEmails()
            }
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
      },
      replyTo(obj) {
        this.replyToName = obj.reply_to
        this.replyToID = obj.email_id
        this.replyToConvID = obj.conv_id
        this.showReplyDialog = true
      },
      isExpanded(index) {
        return this.emails[index].expanded || false
      },
      expandEmail(index) {
        this.emails[index].expanded = !this.emails[index].expanded
      },
      getSupportEmails(page) {
        page = page || this.page

        this.loading = true
        this.$axios({
          method: 'POST',
          url: `admin/supportemails/get/` + page,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || '',
          }
        })
          .then((res) => {
            if (!res.data.emails.length) {
              this.$emit('message',
                {
                  error: false,
                  showDialog: true,
                  message: 'No support emails found'
                })
            } else if (res.data.error) {
              this.$emit('message',
                {
                  showDialog: true,
                  error: res.data.error,
                  message: res.data.message
                })
            }
            this.emails = res.data.emails
            this.perPage = res.data.perPage
            this.page = res.data.page
            this.totalPages = res.data.totalPages
            this.loading = false
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
            this.loading = false
          })
      },
    }
  }
</script>
